import * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import gql from 'graphql-tag'

const DOC = gql`
  query GetSpaceSurveyConfiguration(
    $tenantId: ID!
    $zoneId: ID!
    $appId: ID!
    $scenarioId: ID!
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        app(id: $appId) {
          scenario(id: $scenarioId) {
            extra {
              space {
                surveyConfiguration {
                  code
                  functionalUsage {
                    requireFunctionalUsageAssignmentsForSelectedAccounts
                    requireSponsoredAccountAssignmentsForSponsoredFunctionalUsages
                  }
                  id
                  name
                  tools {
                    allowUsersToUnlockRoomsDirectly
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.default(
  graphql.transformers.OUT.select<
    graphql.schema.GetSpaceSurveyConfigurationQuery,
    ents.extra.space.SurveyConfiguration | undefined,
    'tenant'
  >(
    'tenant',
    graphql.transformers.OUT.select(
      'zone',
      graphql.transformers.OUT.select(
        'app',
        graphql.transformers.OUT.select(
          'scenario',
          graphql.transformers.OUT.select(
            'extra',
            graphql.transformers.OUT.select(
              'space',
              graphql.transformers.OUT.select(
                'surveyConfiguration',
                graphql.transformers.OUT.object({
                  code: transformers.PASS_THROUGH,
                  functionalUsage: graphql.transformers.OUT.object({
                    requireFunctionalUsageAssignmentsForSelectedAccounts:
                      transformers.PASS_THROUGH,
                    requireSponsoredAccountAssignmentsForSponsoredFunctionalUsages:
                      transformers.PASS_THROUGH,
                  }),
                  id: graphql.transformers.OUT.validate(
                    transformers.PASS_THROUGH,
                    ents.extra.space.SurveyConfiguration.Id.assertIsId,
                    { warnOnly: true },
                  ),
                  name: transformers.PASS_THROUGH,
                  tools: graphql.transformers.OUT.nonNull(
                    graphql.transformers.OUT.object({
                      allowUsersToUnlockRoomsDirectly:
                        transformers.PASS_THROUGH,
                    }),
                  ),
                }),
              ),
            ),
          ),
        ),
      ),
    ),
  ),
  undefined,
)

export const executor = graphql.createExecutor<
  graphql.schema.GetSpaceSurveyConfigurationQuery,
  ents.extra.space.SurveyConfiguration | undefined,
  graphql.schema.GetSpaceSurveyConfigurationQueryVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
